"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = exports.fetch = exports.bundleUrl = exports.deserialize = exports.serialize = exports.defaultHost = void 0;
var Id_1 = require("./Id");
var Logic_1 = require("./Logic");
exports.defaultHost = 'https://pi-base-bundles.s3.us-east-2.amazonaws.com';
function serialize(bundle) {
    return {
        properties: Array.from(bundle.properties.values()),
        spaces: Array.from(bundle.spaces.values()),
        theorems: Array.from(bundle.theorems.values()),
        traits: Array.from(bundle.traits.values()),
        version: bundle.version
    };
}
exports.serialize = serialize;
function deserialize(serialized) {
    return {
        properties: indexBy(serialized.properties, function (p) { return p.uid; }),
        spaces: indexBy(serialized.spaces, function (s) { return s.uid; }),
        theorems: indexBy(serialized.theorems, function (t) { return t.uid; }),
        traits: indexBy(serialized.traits, Id_1.traitId),
        version: serialized.version
    };
}
exports.deserialize = deserialize;
function bundleUrl(_a) {
    var branch = _a.branch, _b = _a.host, host = _b === void 0 ? exports.defaultHost : _b;
    return host + "/refs/heads/" + branch + ".json";
}
exports.bundleUrl = bundleUrl;
function fetch(opts) {
    return __awaiter(this, void 0, void 0, function () {
        var headers, response, json, deserialized;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    headers = new Headers();
                    if (opts.etag) {
                        headers.append('If-None-Match', opts.etag);
                    }
                    return [4 /*yield*/, window.fetch(bundleUrl(opts), { method: 'GET', headers: headers })];
                case 1:
                    response = _a.sent();
                    if (response.status === 304) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    deserialized = deserialize(json);
                    if (JSON.stringify(serialize(deserialized)) != JSON.stringify(json)) {
                        throw new Error('Data serialization failure');
                    }
                    return [2 /*return*/, {
                            bundle: deserialized,
                            etag: response.headers.get('etag') || ''
                        }];
            }
        });
    });
}
exports.fetch = fetch;
function indexBy(collection, key) {
    return new Map(collection.map(function (value) { return [key(value), value]; }));
}
function check(bundle, space, implications) {
    if (!implications) {
        implications = new Logic_1.ImplicationIndex(Array.from(bundle.theorems.values()));
    }
    var traitMap = new Map();
    bundle.properties.forEach(function (_, property) {
        var trait = bundle.traits.get(Id_1.traitId({ space: space.uid, property: property }));
        if (!trait) {
            return;
        }
        traitMap.set(property, trait.value);
    });
    var prover = new Logic_1.Prover(implications, traitMap);
    var contradiction = prover.run();
    if (contradiction) {
        return { kind: 'contradiction', contradiction: contradiction };
    }
    var _a = prover.derivations().proofs, proofs = _a === void 0 ? [] : _a;
    var newTraits = new Map();
    proofs.forEach(function (_a) {
        var property = _a.property, value = _a.value, proof = _a.proof;
        var uid = Id_1.traitId({ space: space.uid, property: property });
        var trait = {
            uid: uid,
            counterexamples_id: undefined,
            space: space.uid,
            property: property,
            value: value,
            proof: proof,
            description: '',
            refs: []
        };
        newTraits.set(uid, trait);
    });
    return {
        kind: 'bundle',
        bundle: __assign(__assign({}, bundle), { traits: new Map(__spreadArrays(Array.from(bundle.traits.entries()), Array.from(newTraits.entries()))) })
    };
}
exports.check = check;
